import type { GetOrdersResponse } from "@vue-storefront/prestashop-api";

export default (psOrders: GetOrdersResponse['psdata']) => {
    const populateOrdersList = psOrders.map((order) => ({
        id: order.id_order,
        reference: order.reference,
        date: order.date_add,
        status: order.order_state,
        statusColor: order.order_state_color,
        total: order.total
    }));
    return populateOrdersList;
};